
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12 1C5.928 1 1 5.928 1 12s4.928 11 11 11 11-4.928 11-11S18.072 1 12 1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12 15.9a1.257 1.257 0 110 2.513 1.257 1.257 0 010-2.514zm.006-10.313c.65 0 1.178.527 1.178 1.178v6.143a1.179 1.179 0 01-2.357 0V6.765c0-.65.528-1.178 1.179-1.178z","fill":"#FFF"}})])])
          )
        }
      }
    